import { Location } from '@angular/common'
import { inject, InjectionToken } from '@angular/core'
import { DEFAULT_LANGUAGE, getEnumValues, Language } from '@pai/commons'

import { RoutePath } from 'app/static/route-path.enum'

export const CURRENT_LANG = new InjectionToken<Language>(ngDevMode ? 'CURRENT_LANG' : '', {
  providedIn: 'root',
  // if we have problems try this: readLanguageValue(inject(DOCUMENT).location.pathname)
  factory: () => readLanguageValue(inject(Location).path()),
})

const LANG_OPTS = getEnumValues(Language).join('|')

const PREVIEW_LIVE_PATH = `${RoutePath.PREVIEW}/${RoutePath.PREVIEW__LIVE}`
const PREVIEW_DRAFT_PATH = `${RoutePath.PREVIEW}/${RoutePath.PREVIEW__DRAFT}`

const LANGUAGE_REGEX = new RegExp(
  `^/((${LANG_OPTS})|${PREVIEW_DRAFT_PATH}/(${LANG_OPTS})|${PREVIEW_LIVE_PATH}/(${LANG_OPTS}))/?`,
)

export function readLanguageValue(path: string) {
  const match = LANGUAGE_REGEX.exec(path)

  return match ? ((match[2] || match[3] || match[4]) as Language) : DEFAULT_LANGUAGE
}
